/**
 * @generated SignedSource<<a753ae50fd9503e48119aad456b648ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ConfigureMarketingEmailSenderInput = {
  id: string;
  replyToEmail?: string | null | undefined;
  senderEmail: string;
  senderName: string;
};
export type MarketingEmailDetailsViewConfigureSenderMutation$variables = {
  input: ConfigureMarketingEmailSenderInput;
};
export type MarketingEmailDetailsViewConfigureSenderMutation$data = {
  readonly configureMarketingEmailSender: {
    readonly id: string;
    readonly replyToEmail: string | null | undefined;
    readonly senderEmail: string;
    readonly senderName: string;
  };
};
export type MarketingEmailDetailsViewConfigureSenderMutation = {
  response: MarketingEmailDetailsViewConfigureSenderMutation$data;
  variables: MarketingEmailDetailsViewConfigureSenderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MarketingEmail",
    "kind": "LinkedField",
    "name": "configureMarketingEmailSender",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "senderName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "senderEmail",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "replyToEmail",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MarketingEmailDetailsViewConfigureSenderMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MarketingEmailDetailsViewConfigureSenderMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1752346573755d06a5904e54221c24e4",
    "id": null,
    "metadata": {},
    "name": "MarketingEmailDetailsViewConfigureSenderMutation",
    "operationKind": "mutation",
    "text": "mutation MarketingEmailDetailsViewConfigureSenderMutation(\n  $input: ConfigureMarketingEmailSenderInput!\n) {\n  configureMarketingEmailSender(input: $input) {\n    id\n    senderName\n    senderEmail\n    replyToEmail\n  }\n}\n"
  }
};
})();

(node as any).hash = "a213b4de4a92d3ca877e6cb25060d3ef";

export default node;
